export const ORIGIN_BLOG_MEMBERS_AREA = 'blog-members-area';
